<ng-container *ngIf="userAttributes$|async"></ng-container>
<ng-container *ngIf="cognitoSsoUrl$|async"></ng-container>

<div class="profile-container">
  <ng-container *ngIf="isLoading; else mainView">
    <div style="padding: 20px; display: flex; justify-content: center">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </ng-container>
  <ng-template #mainView>
    <ng-container *ngIf="viewMode ; else editMode">
      <div class="profile-top-row">
        <h1 class="profile-header">{{'profile'| translation}}</h1>
        <div class="profile-button-wrapper" >
          <p-button
            *ngIf="hasMfa&&!isSSOEnabled"
            variant="text"
            severity="link"
            (click)="openMfaOptions()"
          >
            Update MFA
          </p-button>
          <p-button
            variant="text"
            severity="link"
            (click)="viewMode = false"
          >
          {{'edit'| translation}} {{'profile'| translation}}
          </p-button>
        </div>
      </div>

      <div class="col-md-5">
        <div class="profile-item">
          <label class="profile-item-title">{{'name_first'| translation}}</label>
          <p class="profile-item-content">{{ userInfo?.first_name||userInfo?.given_name }}</p>
        </div>
        <div class="profile-item">
          <label class="profile-item-title">{{'name_last'| translation}}</label>
          <p class="profile-item-content">{{userInfo?.last_name||userInfo?.family_name }}</p>
        </div>
        <div class="profile-item-row">
          <div class="profile-item">
            <label class="profile-item-title">{{'username'| translation}}</label>
            <p class="profile-item-content">{{ userInfo?.cognito_username||userInfo?.username }}</p>
          </div>
        </div>
      </div>

      <div class="col-md-5">
        <div class="profile-item">
          <div style="display: flex; align-items: flex-start">
            <label class="profile-item-title">{{'email'| translation}}</label>
            <a *ngIf="!isSSOEnabled && !userInfo?.email_verified && userInfo?.email" (click)="openVerifyModal('email')">{{'verify'| translation}}</a>
          </div>

          <p class="profile-item-content">{{ userInfo?.email }}</p>
        </div>
        <div class="profile-item">
          <div style="display: flex; align-items: flex-start">
            <label class="profile-item-title">{{'phone_number'| translation}}</label>
            <!-- <a *ngIf="!isSSOEnabled &&!userInfo?.phone_number_verified && userInfo?.phone_number?.e164Number" (click)="openVerifyModal('phone_number')">{{'verify'| translation}}</a> -->
          </div>
          <p class="profile-item-content">
            {{ userInfo?.phone_number?.e164Number }}
          </p>
        </div>

        <div class="profile-item">
          <label class="profile-item-title">{{'role'| translation}}</label>
          <p class="profile-item-content">{{ roleName }}</p>
        </div>
      </div>

      <div class="col-md-2">
        <div class="profile-item">
          <label class="profile-item-title">{{'headshot'| translation}}</label>

          <img
            *ngIf="userInfo?.picture"
            [src]="userInfo.picture"
            alt=""
            style="margin-top: 0.3rem"
            height="170px"
            width="170px"
          />
        </div>
      </div>
    </ng-container>
    <!-- EDIT SECTION -->
    <ng-template #editMode>
      <div class="profile-top-row">
        <h1 class="profile-header">{{'profile'| translation}}</h1>
      </div>
      <app-view
        *ngIf="profile?.data&&editView?.data?.content&&editView"
        [items]="editView.data?.content"
        [info]="editView"
        [data]="profile.data"
      ></app-view>
      <div class="profile-btn-container">
        <p-button
          severity="secondary"
          (click)="viewMode = true"
        >
        {{'cancel'| translation}}
        </p-button>
        <p-button
          severity="primary"
          (click)="saveProfile()"
          [disabled]="disableSave"
        >
        {{'save'| translation}}
        </p-button>
      </div>
    </ng-template>
  </ng-template>
</div>
